var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ml-2 mb-2 rounded-lg",attrs:{"elevation":"12"}},[_c('h2',{staticClass:"tw-text-center mt-2 mb-0"},[_vm._v("Sales by Type")]),_c('CreditCardBrandCountWidget')],1)}
var staticRenderFns = []

export { render, staticRenderFns }